// import the Google Cloud Storage client library
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const downloadFiles = (files, filename) => {
  const storage = getStorage();

  if (files.length === 1) {
    getDownloadURL(ref(storage, files[0])).then((url) => {
      saveAs(
        url,
        filename ?? files[0].substring(files[0].lastIndexOf('/') + 1)
      );
    });

    return;
  }

  const zip = new JSZip();
  const promises = [];
  files.forEach((file) => {
    promises.push(
      getDownloadURL(ref(storage, file))
        .then((url) => fetch(url))
        .then((response) => response.blob())
        .then((blob) => {
          zip.file(file.substring(file.lastIndexOf('/') + 1), blob, {
            binary: true,
          });
          return blob;
        })
        .catch((err) => {
          // Handle Firebase error
          // eslint-disable-next-line no-console
          console.log('error', err);
          throw err;
        })
    );
  });
  Promise.all(promises).then(() => {
    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, filename ?? 'files.zip');
    });
  });
};

export default downloadFiles;
